import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate } from '@tyler-components-web/core';
import { SCAFFOLD_CONSTANTS } from './scaffold-constants';
var template = require('./scaffold.html');
var styles = require('./scaffold.css');
/**
 * The custom element class behind the `<tcw-scaffold>` element.
 */
var ScaffoldComponent = /** @class */ (function (_super) {
    __extends(ScaffoldComponent, _super);
    function ScaffoldComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, SCAFFOLD_CONSTANTS.elementName, template, styles);
        return _this;
    }
    ScaffoldComponent = __decorate([
        CustomElement({
            name: SCAFFOLD_CONSTANTS.elementName
        })
    ], ScaffoldComponent);
    return ScaffoldComponent;
}(HTMLElement));
export { ScaffoldComponent };
